import styled, { css } from 'vue-styled-components';

import theme from '@/config/theme';

const modifiers = {
  type: {
    primary: () => css`
      color: ${theme.colors.primary};
    `,
    success: () => css`
      color: ${theme.colors.supportSuccessDark};
    `,
    error: () => css`
      color: ${theme.colors.supportErrorDark};
    `,
    info: () => css`
      color: ${theme.colors.gray6};
  `,
  },
};

const modalProps = {
  type: String,
  visible: Boolean,
};

export const ModalTypes = ['primary', 'success', 'error', 'info'] as const;

export type ModalProps = {
  type: typeof ModalTypes[number];
  visible: boolean;
};

export const Container = styled('div', modalProps)`
  ${({ type }: ModalProps) => css`
    align-items: center;
    background-color: ${theme.colors.white};
    border-radius: ${theme.border.radius.xsmall};
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 40px 80px;
    position: relative;
    text-align: center;
    width: 640px;

    ${modifiers.type[type]}

    h6 {
      font-weight: ${theme.font.bold};
      margin-bottom: ${theme.spacings.medium};
      margin-top: ${theme.spacings.xlarge};
    }

    p {
      color: ${theme.colors.gray6};
      font-size: ${theme.font.sizes.p1};
      line-height: ${theme.font.lineHeights.p1};
    }

    .close {
      position: absolute;
      right: 32px;
      top: 40px;
    }

    .buttons {
      display: flex;
      gap: ${theme.spacings.medium};
      margin-top: ${theme.spacings.xxlarge};
    }
  `}
`;

export const Wrapper = styled('div', modalProps)`
  ${({ visible }: ModalProps) => css`
    align-items: center;
    background-color: rgba(0, 0, 0, .45);
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    opacity: 1;
    position: fixed;
    top: 0;
    transition: opacity .3s;
    width: 100%;
    z-index: ${theme.layers.overlay};

    ${!visible && 'opacity: 0; z-index: 0; pointer-events: none;'}
  `}
`;
